var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "grid-list-xl": "", fluid: "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs8: "", "offset-xs2": "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Width" },
                model: {
                  value: _vm.width,
                  callback: function($$v) {
                    _vm.width = $$v
                  },
                  expression: "width"
                }
              }),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: { label: "drop" },
                model: {
                  value: _vm.drop,
                  callback: function($$v) {
                    _vm.drop = $$v
                  },
                  expression: "drop"
                }
              }),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: { label: "Price" },
                model: {
                  value: _vm.price,
                  callback: function($$v) {
                    _vm.price = $$v
                  },
                  expression: "price"
                }
              }),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "app_price_btn",
                  attrs: { large: "", color: "primary" },
                  on: { click: _vm.addPrice }
                },
                [_vm._v("Add")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40b83ba4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40b83ba4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/prices/NewPrice.vue
// module id = null
// module chunks = 